import { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { dotPath, isNilOrEmpty } from 'ramdasauce'
import { Link } from 'gatsby'

import { useStyles } from './styles'
import { Text } from 'components/atoms'
import { CartItem } from 'components/molecules'
import { StoreContext } from 'context'
import { ROUTES } from 'utils/constants'

export const CartGrid = ({
  data: { sanityProduct, sanityVariantProduct, productData },
}) => {
  const classes = useStyles()

  const {
    store: { checkout, loading },
  } = useContext(StoreContext)

  const [cartItems, setCartItems] = useState([])

  useEffect(() => {
    setCartItems(
      checkout.lineItems.map((item) => {
        return item
      })
    )
  }, [checkout])

  const getMediaIds = (media, variant) => {
    if (variant) {
      return media.variants.map((variant) => variant.variant)
    } else {
      return [dotPath('shopifyProduct', media)]
    }
  }

  const productMerge = (media, product) =>
    cartItems.map((cartItem) => ({
      shopifyData: {
        ...product.find((productItem) => {
          const productIds = productItem.variants.map(
            (variant) => variant.storefrontId
          )
          const cartIds = cartItem.variant.id

          return productIds.includes(cartIds)
        }),
      },
      mediaData: {
        ...media.find((mediaItem) => {
          const cartIds = cartItem.variant.id

          const mediaIds = getMediaIds(
            mediaItem,
            !isNilOrEmpty(dotPath('variants', mediaItem))
          )

          return mediaIds.includes(cartIds)
        }),
      },
      cartData: { ...cartItem },
    }))

  const data = [
    ...productMerge(sanityProduct, productData),
    ...productMerge(sanityVariantProduct, productData),
  ]
  const filteredData = data.filter((d) => !isNilOrEmpty(d.mediaData) && d)
  const empty = checkout.lineItems.length <= 0

  const handleCheckout = () => {
    window.open(checkout.webUrl)
  }

  const renderGrid = (products) => {
    return products.map((product, i) => {
      return <CartItem data={product} key={i} />
    })
  }

  const cartContents = empty ? (
    <div className={classes.emptyCart}>
      <Text className={classes.empty}>Your cart is empty!</Text>
      <Link className={classes.continueShopping} to={ROUTES.SHOP}>
        <Text size="body7">Continue Shopping</Text>
      </Link>
    </div>
  ) : (
    <>
      {renderGrid(filteredData)}
      <div className={classes.subtotalGrid}>
        <div className={classes.subtotal}>
          <Text size="label4" tag="p">
            Subtotal
          </Text>
          <Text size="label4" tag="p">
            ${checkout.subtotalPrice}
          </Text>
        </div>
        <div className={classes.subtotal}>
          <Text size="label4" tag="p">
            Shipping & Taxes
          </Text>
          <Text size="label4" tag="p">
            Calculated at checkout
          </Text>
        </div>
      </div>
      <div className={classes.total}>
        <Text size="label4" tag="p" className={classes.bold}>
          Total
        </Text>
        <Text size="label4" tag="p" className={classes.bold}>
          ${checkout.subtotalPrice}
        </Text>
      </div>
      <button className={classes.checkout} onClick={handleCheckout}>
        <Text size="body6">Checkout</Text>
      </button>
    </>
  )

  return (
    <div className={classes.wrapper}>
      <Text tag="h1" size="header5" className={classes.title}>
        CART
      </Text>
      <div className={classes.line} />
      {!loading && cartContents}
    </div>
  )
}

CartGrid.propTypes = {
  text: PropTypes.string,
}

CartGrid.defaultProps = {
  text: 'CartGrid',
}
